"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOrderPreparationStep = exports.IconOrderReopeningCart = exports.DateContainer = exports.WithLinkContainer = exports.ChoiceRadio = exports.OrderLink = exports.RadioLabel = exports.OrderDate = exports.NewOrderChoiceContainer = exports.OrderChoiceContainer = void 0;
const OrderPreparationStep_1 = __importDefault(require("@kawaui/icons/build/icons/ordersStatus/OrderPreparationStep"));
const OrderReopeningCart_1 = __importDefault(require("@kawaui/icons/build/icons/ordersStatus/OrderReopeningCart"));
const link_1 = require("@kawaui/link");
const radio_1 = require("@kawaui/radio");
const styled_components_1 = __importStar(require("styled-components"));
exports.OrderChoiceContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: ${({ theme }) => `${theme.space.s200} ${theme.space.s200} ${theme.space.s100} ${theme.space.s200}`};
  border: 1px solid ${({ theme }) => theme.colors.gray.s300};
  margin-bottom: ${({ theme }) => theme.space.s200};

  border-radius: ${({ theme }) => theme.radius.s100};

  cursor: pointer;

  ${({ theme, isActive }) => isActive &&
    (0, styled_components_1.css) `
      :before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-left: 4px solid ${theme.colors.main.base};
      }
      box-shadow: ${theme.shadow.z2};
    `};

  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.z2};
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 82px;
    padding: ${({ theme }) => `${theme.space.s200} ${theme.space.s200} ${theme.space.s200} ${theme.space.s300}`};
  }
`;
exports.NewOrderChoiceContainer = (0, styled_components_1.default)(exports.OrderChoiceContainer) `
  height: 50px;
  padding: ${({ theme }) => theme.space.s200} ${({ theme }) => theme.space.s150};
  margin-top: ${({ theme }) => theme.space.s150};
  margin-bottom: 0;
`;
exports.OrderDate = styled_components_1.default.span `
  margin: ${({ theme }) => `${theme.space.s100} auto 0 ${theme.space.s400}`};

  color: ${({ theme }) => theme.colors.gray.s600};

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.smallText)};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    margin: 0 0 0 auto;
  }
`;
exports.RadioLabel = styled_components_1.default.span `
  display: inline-flex;
  width: 100%;

  color: ${({ theme }) => theme.colors.gray.s700};

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.smallText)}
`;
exports.OrderLink = (0, styled_components_1.default)(link_1.Link) `
  margin: ${({ theme }) => `${theme.space.s100} auto 0 ${theme.space.s400}`};

  text-decoration: underline;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    margin: ${({ theme }) => `${theme.space.s100} auto 0 ${theme.space.s300}`};
  }
`;
exports.ChoiceRadio = (0, styled_components_1.default)(radio_1.Radio) `
  flex: 1;
`;
exports.WithLinkContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: 100%;
  }
`;
exports.DateContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;
exports.IconOrderReopeningCart = (0, styled_components_1.default)(OrderReopeningCart_1.default) `
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    display: block;
    margin-right: ${({ theme }) => theme.space.s200};
  }
`;
exports.IconOrderPreparationStep = (0, styled_components_1.default)(OrderPreparationStep_1.default) `
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    display: block;
    margin-right: ${({ theme }) => theme.space.s200};
  }
`;
